import Index from '@/pages/Product/Index';
import Products from '@/pages/Product/List';
import ProductFilter from '@/pages/Product/Filter';
import ProductDetail from '@/pages/Product/Detail/Index';
import ProductCreate from '@/pages/Product/Create';

export default {
  path: '',
  component: Index,
  children: [
    {
      path: 'all',
      name: 'ListingAll',
      component: Products,
    }, {
      path: 'rejected',
      name: 'ListingRejected',
      component: Products,
      meta: {
        queryType: 'REJECTED',
      },
    }, {
      path: 'out-of-stock',
      name: 'ListingOutOfStock',
      component: Products,
      meta: {
        queryType: 'OUT_OF_STOCK',
      },
    }, {
      path: 'on-sale',
      name: 'ListingOnSale',
      component: Products,
      meta: {
        queryType: 'ON_SALE',
      },
    }, {
      path: 'not-on-sale',
      name: 'ListingNotOnSale',
      component: Products,
      meta: {
        queryType: 'NOT_ON_SALE',
      },
    }, {
      path: 'action-needed',
      name: 'ListingActionNeeded',
      component: Products,
      meta: {
        queryType: 'ACTION_NEEDED',
      },
    },
    {
      path: 'archived',
      name: 'ListingArchived',
      component: Products,
      meta: {
        queryType: 'ARCHIVED',
      },
    },
    {
      path: 'create',
      redirect: 'products/create',
    },
    {
      path: 'products/create',
      name: 'ProductCreate',
      component: ProductCreate,
    }, {
      path: 'filter',
      redirect: 'products/filter',
    }, {
      path: 'products/filter',
      name: 'ProductFilter',
      component: ProductFilter,
    }, {
      path: ':productId',
      name: 'ProductDetail',
      component: ProductDetail,
    },
  ],
};
